"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var Platform = require("./platform");
var constants_1 = require("../data/constants");
var filter = function (condition) {
    return Platform.current()
        .then(function (platform) {
        if (!platform) {
            return [];
        }
        return platform["offers"]
            .filter(condition);
    });
};
var all = function (type) {
    return filter(function (e) { return e["service_type"] === type; });
};
exports.all = all;
var prepaidMinutes = function () {
    return all("prepaid_minute");
};
exports.prepaidMinutes = prepaidMinutes;
var phone = function () {
    return all("phone")
        .then(function (offers) { return offers[0]; });
};
exports.phone = phone;
var promotions = function () {
    return filter(function (e) { return e["promotion"]; });
};
exports.promotions = promotions;
var customOffers = function () {
    return Platform.current()
        .then(function (platform) {
        if (!platform.settings.custom_offers) {
            return [];
        }
        return Request.sendGet(constants_1.endpoints.api + "/custom_offers");
    });
};
exports.customOffers = customOffers;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/offers/" + id);
};
exports.get = get;
//# sourceMappingURL=offer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/offer.js
// module id = 908
// module chunks = 3